export { default as base } from '@theme-ui/preset-base';
export { default as dark } from '@theme-ui/preset-dark';
export { default as deep } from '@theme-ui/preset-deep';
export { default as funk } from '@theme-ui/preset-funk';
export { default as future } from '@theme-ui/preset-future';
export { default as roboto } from '@theme-ui/preset-roboto';
export { default as swiss } from '@theme-ui/preset-swiss';
export { default as system } from '@theme-ui/preset-system';
export { default as tosh } from '@theme-ui/preset-tosh';
export { default as bootstrap } from '@theme-ui/preset-bootstrap';
export { default as bulma } from '@theme-ui/preset-bulma';
export { default as polaris } from '@theme-ui/preset-polaris';
export { default as tailwind } from '@theme-ui/preset-tailwind';
export { default as sketchy } from '@theme-ui/preset-sketchy';
